export const CYPRESS_MEMBERSHIP_REACTIVATION_COMPLETE_EVENT =
  "gl:cypress-membership-reactivated";

export const CYPRESS_MEMBERSHIP_REACTIVATION_TIMEOUT_EVENT =
  "gl:cypress-membership-reactivation-timeout";
